import React, { useEffect, useState } from 'react';
import AceEditor from 'react-ace';
import "ace-builds/webpack-resolver";
import 'ace-builds/src-noconflict/mode-lua';
import 'ace-builds/src-noconflict/theme-monokai';
import "ace-builds/src-noconflict/ext-language_tools"
import 'ace-builds/src-noconflict/worker-lua';
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Container, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Tooltip, useDisclosure } from '@chakra-ui/react';
import { useRunCode } from '../reducer/runCodeReducer';
import * as luainjs from 'lua-in-js'
import { addDoc, collection, doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
interface LuaCodeEditorProps {
  _id: any;
}
var luaEnv: any
export default function LuaCodeEditor({ _id }: LuaCodeEditorProps) {
  let navigate = useNavigate()
  const { state, dispatch } = useRunCode();
  const [isShare, setIsShare] = useState(_id !== undefined)
  const [codeDataBase, setCodeDataBase] = useState("")
  const [code, setCode] = useState<string>(state.codeData);


  useEffect(() => {
    if (_id == undefined) {

      setCode(state.codeData)
    }
  }, [state.codeData])
  const { showConsole, codeData, share } = state;
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [output, setOutput] = useState("")
  const getDocDataPre = async () => {
    if (!_id || !state.user) return;
    
    setIsShare(_id !== undefined);
    const userRef = doc(db, 'pubCode', _id);
    try {
      const userDoc = await getDoc(userRef);
      if (userDoc.exists()) {
        if (await userDoc.data().lock == true) {
          if (await userDoc.data().auth == state.user.email) {
            dispatch({ type: "noti", title: "Lưu ý", content: "Chỉ có bạn có thể xem được file người khác sẽ không!", icon: "error" });
            setCode(userDoc.data().code);
            setCodeDataBase(userDoc.data().code);
            return userDoc.data();
          } else {
            dispatch({ type: "noti", title: "Cảnh báo", content: "Nó bị khóa rồi!", icon: "error" });
            return;
          }
        } else {
          setCode(userDoc.data().code);
          setCodeDataBase(userDoc.data().code);
          return userDoc.data();
        }
      } else {
        dispatch({ type: "noti", title: "Lỗi", content: "Code không tồn tại.", icon: "error" });
        navigate("../");
        return "";
      }
    } catch (e) {
      navigate("/");
      dispatch({ type: "noti", title: "Cảnh báo", content: "Nó có thể bị khóa rồi hoặc lỗi!", icon: "error" });
      return "";
    }
  };

  const getDocDataPub = async () => {
    setIsShare(_id!==undefined)
    const userRef = doc(db, 'pubCode', _id);
    try {
      const userDoc = await getDoc(userRef);
      if (userDoc.exists()) {
        setCode(userDoc.data().code)
        setCodeDataBase(userDoc.data().code)
        return userDoc.data();

      } else {
        dispatch({type:"noti",title:"Lỗi",content:"Code không tồn tại.",icon:"error"})
        navigate("../")
        return ""
      }
    } catch (e) {
      alert(e)
      navigate("/")
      return ""
    }
  }

  const shareNewCode = async () => {

    if (code === '') {
      dispatch({ type: "noti", title: "Thất bại", content: "Code rỗng", icon: "error" })
      return;
    }
    if (state.user != null) {

      if (_id == null || _id == undefined) {
        const docRef = await addDoc(collection(db, "pubCode"), {
          auth: state.user.email,
          code: code,
          send_at: new Date(),
          lock: false
        })
        setCodeDataBase(code)
        setIsShare(true)
        dispatch({ type: "noti", title: "Thành công", content: "Bạn có thể chia sẻ code theo link này: " + window.location.host + "/" + docRef.id, icon: "success" })

        navigate("/" + docRef.id)
      } else {

        const userRef = doc(db, 'pubCode', _id);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          if (userDoc.data().auth == state.user.email) {
            try {
              await updateDoc(userRef, {
                auth: state.user.email,
                code: code,
                edit_at: new Date()
              });
              setCodeDataBase(code)
              setIsShare(true)
              dispatch({ type: "noti", title: "Thành công", content: "Cập nhập code thành công", icon: "success" })
            } catch (e) {
              console.error('Error updating document: ', e);
            }
          } else {
            confirmAlert({
              title: 'Tạo mới code',
              message: 'Do code này không phải của bạn nên chúng tôi sẽ copy vào không gian làm việc mới và chia sẽ nó',
              buttons: [
                {
                  label: 'Xác nhận',
                  onClick: async () => {
                    const docRef = await addDoc(collection(db, "pubCode"), {
                      auth: state.user.email,
                      code: code,
                      send_at: new Date(),
                      lock: false
                    })
                    dispatch({ type: "noti", title: "Cảnh báo", content: "Bạn có thể chia sẻ code theo link này: " + window.location.host + "/" + docRef.id, icon: "success" })
                    navigate("/" + docRef.id)
                  }

                },
                {
                  label: 'Hủy',
                }
              ]
            });



          }
        }


      }

    } else {
      dispatch({ type: "noti", title: "Vui lòng đăng nhập", content: "Đăng nhập để có thể thêm và sửa code", icon: "error" })
    }

  }
  useEffect(() => {
    if (share) {
      shareNewCode()
    }
    dispatch({ type: "share", status: false })

  }, [share])
  function editOutPut(newcode: any) {
    setOutput(prevOutput => prevOutput + '<br>' + newcode);

  }
  //useEffect(() => {
  //  const initLuaEngine = async () => {
  //    luaEnv = luainjs.createEnv({ stdout: editOutPut })
  //  };
  //  initLuaEngine();
  //  if (_id != null || _id != undefined) {
  //    if (state.user.email) {
  //      getDocData()
  //    }
  //  }
  //}, [state.user, _id])

  useEffect(() => {
    const initLuaEngine = async () => {
      luaEnv = luainjs.createEnv({ stdout: editOutPut })
    };
    initLuaEngine();

    if (_id != null && _id != undefined) {
      const fetchData = async () => {
        const userRef = doc(db, 'pubCode', _id);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          if (userDoc.data().lock === false) {
            await getDocDataPub();
          } else if (userDoc.data().lock === true && state.user) {
            await getDocDataPre();
          } else {
            navigate("/");
            dispatch({ type: "noti", title: "Cảnh báo", content: "Nó đã bị khóa!", icon: "error" });
          }
        } else {
          navigate("/");
          dispatch({ type: "noti", title: "Lỗi", content: "Code không tồn tại", icon: "error" });
        }
      };
      fetchData();
    }
  }, [_id, state.user]);

  async function runLuaCode(luaCode: string) {
    try {
      setOutput("")
      const luaScript = luaEnv.parse(luaCode)
      luaScript.exec()
    } catch (error) {
    }
  };
  useEffect(() => {
    dispatch({ type: "updateCode", code: code })
  }, [code])
  useEffect(() => {
    if (showConsole) {
      runLuaCode(state.codeData)
      onOpen()
    }
  }, [showConsole])
  const handleChange = (newCode: string) => {
    setIsShare(codeDataBase == newCode)
    setCode(newCode);
  };

  return (
    <>
      <AceEditor
        mode="lua"
        theme="monokai"
        value={code}
        onChange={handleChange}
        name="lua-code-editor"
        editorProps={{ $blockScrolling: true }}
        width="100vw"
        height='90vh'
        setOptions={{
          enableLiveAutocompletion: true,
          enableSnippets: true,
        }}
      ></AceEditor>
      {
        _id ? (<Tooltip label={isShare ? "Đã lưu" : "Chưa lưu"} placement='top' isOpen>
          <Button position={"fixed"}>Code Status</Button>
        </Tooltip>) : (null)
      }


      <Modal
        isCentered
        onClose={() => {
          onClose()
          dispatch({ type: "close" })
        }}
        isOpen={isOpen}
        motionPreset='slideInBottom'
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Console Debug</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div dangerouslySetInnerHTML={{ __html: output.replaceAll("\n", "<br>") }} />
          </ModalBody>

        </ModalContent>
      </Modal>



    </>
  );
};
